var React = require('react');

function LinkedIn (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.32024 5.63043C7.32024 6.53109 6.58024 7.26087 5.66691 7.26087C4.75358 7.26087 4.01358 6.53109 4.01358 5.63043C4.01358 4.73043 4.75358 4 5.66691 4C6.58024 4 7.32024 4.73043 7.32024 5.63043ZM7.33358 8.56522H4.00024V19H7.33358V8.56522ZM12.6549 8.56522H9.34291V19H12.6556V13.5224C12.6556 10.4767 16.6749 10.2276 16.6749 13.5224V19H20.0002V12.3928C20.0002 7.2537 14.0522 7.44087 12.6549 9.97065V8.56522Z","fill":"black"}));
}

LinkedIn.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = LinkedIn;

LinkedIn.default = LinkedIn;
